import React, { useState, useEffect } from 'react';
import { db } from '../../../firebase';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import PersonalBestForm from './PersonalBestForm';
import './krijtbord.css';

function Krijtbord() {
  const [records1bak, setRecords1bak] = useState([]);
  const [records3bak, setRecords3bak] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBakRecords = async () => {
      try {
        setLoading(true);
        
        // Fetch 1BAK records
        const records1bakQuery = query(
          collection(db, 'records1bak'),
          orderBy('position', 'asc')
        );
        
        // Fetch 3BAK records
        const records3bakQuery = query(
          collection(db, 'records3bak'),
          orderBy('position', 'asc')
        );
        
        const [records1bakSnapshot, records3bakSnapshot] = await Promise.all([
          getDocs(records1bakQuery),
          getDocs(records3bakQuery)
        ]);
        
        // Default data for 1BAK
        const default1bakData = [
          { position: 1, time: '02:68', name: 'Ruben' },
          { position: 2, time: '02:75', name: 'Boas' },
          { position: 3, time: '03:00', name: 'Jelmer' },
          { position: 4, time: '03:38', name: 'Dirk' },
          { position: 5, time: '03:45', name: 'Thijs' },
          { position: 6, time: '03:73', name: 'Silvan' },
          { position: 7, time: '03:77', name: 'Jelte' },
          { position: 8, time: '04:05', name: 'Rob' },
          { position: 9, time: '04:08', name: 'Karel' },
          { position: 10, time: '04:36', name: 'Rick' }
        ];
        
        // Default data for 3BAK
        const default3bakData = [
          { position: 1, time: '18:17', name: 'Dirk M.' },
          { position: 2, time: '23:70', name: 'Ruben' },
          { position: 3, time: '31:80', name: 'Jelmer' },
          { position: 4, time: '33:90', name: 'Snip' },
          { position: 5, time: '36:30', name: 'Chris' },
          { position: 6, time: '58:70', name: 'Jelte' },
          { position: 7, time: '61:30', name: 'Marnix' },
          { position: 8, time: '66:00', name: 'Harma' },
          { position: 9, time: '82:40', name: 'Karel' },
          { position: 10, time: '--:--', name: 'T.b.d.' }
        ];
        
        // Process 1BAK records
        if (!records1bakSnapshot.empty) {
          const records1bakList = records1bakSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
          setRecords1bak(records1bakList);
        } else {
          setRecords1bak(default1bakData);
        }
        
        // Process 3BAK records
        if (!records3bakSnapshot.empty) {
          const records3bakList = records3bakSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
          setRecords3bak(records3bakList);
        } else {
          setRecords3bak(default3bakData);
        }
        
        setError(null);
      } catch (err) {
        console.error('Error fetching bak records:', err);
        setError('Failed to load bak records');
        
        // Fallback to default data on error
        setRecords1bak([
          { position: 1, time: '02:68', name: 'Ruben' },
          { position: 2, time: '02:75', name: 'Boas' },
          { position: 3, time: '03:00', name: 'Jelmer' },
          { position: 4, time: '03:38', name: 'Dirk' },
          { position: 5, time: '03:45', name: 'Thijs' },
          { position: 6, time: '03:73', name: 'Silvan' },
          { position: 7, time: '03:77', name: 'Jelte' },
          { position: 8, time: '04:05', name: 'Rob' },
          { position: 9, time: '04:08', name: 'Karel' },
          { position: 10, time: '04:36', name: 'Rick' }
        ]);
        
        setRecords3bak([
          { position: 1, time: '18:17', name: 'Dirk M.' },
          { position: 2, time: '23:70', name: 'Ruben' },
          { position: 3, time: '31:80', name: 'Jelmer' },
          { position: 4, time: '33:90', name: 'Snip' },
          { position: 5, time: '36:30', name: 'Chris' },
          { position: 6, time: '58:70', name: 'Jelte' },
          { position: 7, time: '61:30', name: 'Marnix' },
          { position: 8, time: '66:00', name: 'Harma' },
          { position: 9, time: '82:40', name: 'Karel' },
          { position: 10, time: '--:--', name: 'T.b.d.' }
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchBakRecords();
  }, []);

  if (loading) {
    return (
      <div className="chalkboard-container">
        <div className="loading-message">Loading baktijden...</div>
      </div>
    );
  }

  if (error) {
    console.error(error);
    // Continue rendering with default or fetched data
  }

  return (
    <div>
      <div className="chalkboard-container">
        <div className="chalkboard-tables-wrapper">
          {/* 1BAK Table */}
          <div className="chalkboard-table-container">
            <table className="chalkboard-table">
              <thead>
                <tr>
                  <th colSpan={3}>1 BAK</th>
                </tr>
                <tr className="subheader-row">
                  <th>Nr</th>
                  <th>Tijd</th>
                  <th>Naam</th>
                </tr>
              </thead>
              <tbody>
                {records1bak.map((record) => (
                  <tr key={record.id || record.position}>
                    <td>{record.position}</td>
                    <td>{record.time}</td>
                    <td>{record.name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          {/* 3BAK Table */}
          <div className="chalkboard-table-container">
            <table className="chalkboard-table">
              <thead>
                <tr>
                  <th colSpan={3}>3 BAK</th>
                </tr>
                <tr className="subheader-row">
                  <th>Nr</th>
                  <th>Tijd</th>
                  <th>Naam</th>
                </tr>
              </thead>
              <tbody>
                {records3bak.map((record) => (
                  <tr key={record.id || record.position}>
                    <td>{record.position}</td>
                    <td>{record.time}</td>
                    <td>{record.name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      
      {/* Personal Best Form */}
      <PersonalBestForm />
    </div>
  );
}

export default Krijtbord;